module.exports = __webpack_public_path__ + "img/owlchemist.816725de.png";